import CSS from "csstype";
import React from "react";
import { formatAmount } from "~src/shared/helpers/format";
import { IGetStateHand } from "~src/user/apigen/getState";
import { StateProps } from "./Center";

export const RightPerson: React.FC<StateProps> = ({ state }) => {
  if (state.hands.length === 0) {
    return null;
  }

  const person = state.hands.filter((user: IGetStateHand) => {
    return user.position === (state.position + 1) % 3;
  })[0];

  if (person === undefined) {
    return null;
  }

  return (
    <div style={rightPerson(window.innerWidth < 786)}>
      {person.cardsLeft !== null && person.cardsLeft !== undefined && (
        <div>
          {person.cardsLeft + " card" + (person.cardsLeft === 2 ? "s" : "")}
        </div>
      )}
      {person.dou === true && state.showMiddleCards === true && (
        <div>
          dou
        </div>
      )}
      <div>
        {person.displayName}
      </div>
      <div>
        {formatAmount(person.roomBalance)}
      </div>
      {person.handID === state.landlordHandID && (
        <div>
          L
        </div>
      )}
    </div>
  );
};

const rightPerson = (smallScreen: boolean): CSS.Properties => ({
  position: "absolute",
  top: "45%",
  right: smallScreen ? "30px" : "50px",
  justifyContent: "right",
  alignItems: "right",
  fontSize: "1.5em",
  textAlign: "right",
});
